// extracted by mini-css-extract-plugin
export var progressBar = "_ks-0";
export var progressBarInner = "_ks-1";